<app-banner></app-banner>

<div id="side-navigation">
  <div class="container-fluid mt-4">
    <div class="row">

      <!-- Sidebar -->
      <div class="col-12 col-md-4 col-lg-3 side-menu ps-lg-5">
        <h6>Visit Us</h6>
        <ul class="nav flex-column">
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/visit/how-to-reach">How to Reach</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/visit/city-map">City Map</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/visit/infrastructure">Infrastructure</a>
          </li>
        </ul>
      </div>

      <!-- Main Content -->
      <div class="col-12 col-md-8 col-lg-9">
        <router-outlet></router-outlet>
      </div>

    </div>
  </div>
</div>

